module.exports = __webpack_public_path__ + "static/media/T12 - Montenapoleone.7c6623a3.jpg";